export const HomeCareLeadDaysNeededOptions = [
    { value: "sun", label: "Sun" },
    { value: "mon", label: "Mon" },
    { value: "tue", label: "Tue" },
    { value: "wed", label: "Wed" },
    { value: "thu", label: "Thu" },
    { value: "fri", label: "Fri" },
    { value: "sat", label: "Sat" },
];
export const homeCareLeadDaysNeededValues = HomeCareLeadDaysNeededOptions.map(option => option.value);
//# sourceMappingURL=home-care-lead.js.map